export function getObjectKeys(obj) {
  return Object.keys(obj);
}